import React, { useState } from 'react'
import { dateTimeFormat } from '../../../../../../itrust_common/components/HelperFunctions'
import { visionInsuranceDetailView } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction'
import DateFormatView from '../../../../../../itrust_common/components/others/DateFormatView'
import { syncMemberBenefitLoad } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceMappingActions'
import SyncMemberBenifit from '../visionInsuranceMapping/mappingFields/SyncMemberBenifit'
import { useLocation } from 'react-router-dom'

export default function RPASubmitHistoryListing(props) {
  const { expired_vision_insurance_logs, dispatch, wrapperClasses, order } = props
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const location = useLocation()

  const hideSyncIcon =
    location.pathname.endsWith('/account_information')

  const toggleDropdown = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (openDropdownId === item.id) {
      setOpenDropdownId(null);
    } else {
      setOpenDropdownId(item.id);
      dispatch(syncMemberBenefitLoad({ order_id: order?.id, log_id: item.id }));
    }
  };
  const isHasBenefits = expired_vision_insurance_logs?.find((item) => item.has_benefits === true)
  return (
    <table className={`table shadow-none mb-0  ${wrapperClasses}`}>
      <thead className="">
        <tr>
          <th>Date and Time</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {expired_vision_insurance_logs?.length ? expired_vision_insurance_logs?.map((item) => <tr className='pointer' onClick={(e) => {
          if (e.target.closest('.rpa-sync-menu')) return;
          (item.status === 'found' || item.file) && dispatch(visionInsuranceDetailView({ visible: true, file_url: item.file, service: item.service, id: item.id}))
        }} key={item.id}>
          <td><DateFormatView dateTime={item.timestamp} /></td>
          <td className='vision-insurance-log'>
            {item.status === 'found' ?
              <span className="badge rounded bg-success">Found</span> :
              <span className="badge rounded bg-failed custom-tooltip " data-title={item.error_message}>Not Found
                <i className="las la-info-circle ml-3"></i>
              </span>
            }
          </td>
          <td>
            {item.status === 'found' || item.file ?
              <span className='text-primary font-size-24 mr-3'>
                <i className="las la-eye"></i>
              </span> :
              <span className='text-danger font-size-24 mr-3'>
                <i className="las la-eye-slash"></i>
              </span>
            }
          </td>
          {!hideSyncIcon && isHasBenefits &&
          <td>
            {item.status === 'found' ? (
              <div className="dropdown bg-transparent position-relative rpa-sync-menu">
                  <span
                    className="font-size-24 text-primary"
                    role="button"
                    onClick={(e) => toggleDropdown(e, item)}
                  >
                      <button type='button' className={`btn btn-primary mb-4 font-size-12 py-2 px-4`}>
                        Sync
                      </button>
                  </span>

                  <div
                    className={`dropdown-menu dropdown-menu-right ${openDropdownId === item.id ? 'show' : ''}`}
                    style={{ width: '400px', padding: 0 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <SyncMemberBenifit
                      dispatch={dispatch}
                      expired_vision_insurance_logs={expired_vision_insurance_logs}
                      wrapperClasses="table-hover"
                      orderId={order?.id}
                      onClose={() => setOpenDropdownId(null)}
                    />
                  </div>
              </div>
            ) : null}
          </td>}
        </tr>) :
          <tr className='text-center py-3'>
            <td colSpan={10}>Not Found</td>
          </tr>
        }
      </tbody>
    </table>
  )
}
